export default "__VITE_ASSET__LEjBGxgR__"